import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@cropler/ui-kit';

import { Icon as CroplerIcon } from '@cropler/ui-kit';

import { updateSorting } from '../../store/slices/sensors';
import { BreakpointDesktop, BreakpointMobileUp } from '../../constants/ui';
import { useViewport } from '../../hooks';
import { getFilterParametersMap } from '../../utils/filter';

const FilterOrderButton = ({ t, onChangeOrder, showButtonText, isCustomOrder, arrowPosition }) => {
  const dispatch = useDispatch();
  const { widthViewport } = useViewport();
  const [arrow, setArrow] = useState(arrowPosition);
  const FilterParametersMap = getFilterParametersMap(t);

  const {
    sorting: { dir, parameter, crop },
  } = useSelector((state) => state.sensors);

  const onClickChangeOrder = () => {
    if (!isCustomOrder) {
      dispatch(updateSorting({ dir: dir === '-' ? '' : '-', parameter, crop }));
    }
    if (!onChangeOrder) return;
    onChangeOrder();
  };

  useEffect(() => {
    if (arrowPosition) {
      setArrow(arrowPosition);
    } else {
      setArrow(dir === '-' ? 'des' : 'asc');
    }
  }, [dir, arrowPosition])

  return (
    <Button
      icon={arrow === 'des' ? <CroplerIcon name="asc" /> : <CroplerIcon name="desc" />}
      type="secondary"
      onClick={onClickChangeOrder}
      size={widthViewport < BreakpointMobileUp ? 'large' : null}
    >
      {widthViewport > BreakpointDesktop && showButtonText && (
        <>
          {t('filters.sort')}: {FilterParametersMap[parameter].label}
        </>
      )}
    </Button>
  );
};

export default FilterOrderButton;
